module.exports = __webpack_public_path__ + "static/media/snowman.1b33da7d.svg";